
































































































































































import {
  defineComponent,
  reactive,
  watch,
  ref,
  Ref,
  PropType,
  computed,
  getCurrentInstance,
} from '@vue/composition-api';
import _ from 'lodash';
import { TreeSelectValue, TreeNodeModel } from 'tdesign-vue';
import { HelpCircleIcon } from 'tdesign-icons-vue';

// 引入 compositions
import teamHandler from '@/renderer/views/desktop/ManageConsole/TeamManagement/compositions/teamHandler';
import userValidator from '@/renderer/components/user/compositions/userValidator';

// 引入工具类
import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/smh';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { formatSize, formatSize2Byte } from '@/renderer/scripts/utils/tools/index';
import upgradeDialog from '@/renderer/scripts/utils/upgradeDialog';
export default defineComponent({
  components: {
    HelpCircleIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    type: {
      required: true,
      type: String,
    },
    definiteTeam: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: Number,
      default: -1,
    },
    parentName: {
      type: String,
      default: '',
    },
    currentNode: {
      type: Object,
      default: {
        id: -1,
        name: '',
        space: '',
        used: '',
      },
    },
    teamData: {
      type: Array,
      default: [],
    },
    /**
     * 是否仅列出管辖团队
     */
    needCheckManagementPermission: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const treeData: Ref<any[]> = ref([]);
    const treeKeys = {
      label: 'name',
      value: 'id',
      children: 'children',
    };
    const defaultRoleId = computed(() => store.getters.defaultRoleId);
    const isEdit = computed(() => props.type !== 'add');
    const usedInfo = reactive({
      size: 0,
      unit: 'MB',
    });
    const formData = reactive({
      name: '',
      parentName: '',
      parentId: -1,
      spaceQuotaSize: '',
      unit: 'MB',
      role: defaultRoleId.value,
    });
    // 团队空间大小选项 'shared' | 'customed'
    const spaceConfig = ref('shared');
    const currentName = ref('');
    const currentRole = ref(1);
    const currentTeamSpace = reactive({
      size: '',
      unit: '',
    });
    const { sizeMap, teamNameMaxLength } = ConstantConfig;
    const sizeOptions = Object.keys(sizeMap).map(key => ({
      label: key,
      value: key,
    }));
    const size = computed({
      get() {
        return formData.spaceQuotaSize;
      },
      set(val: string) {
        formData.spaceQuotaSize = val.replace(/\D/g, '');
      },
    });
    const unit = computed({
      get() {
        return formData.unit;
      },
      set(val: string) {
        formData.unit = val;
      },
    });
    const title = computed(() => {
      if (isEdit.value) return i18n_t('编辑团队');
      return props.definiteTeam ? i18n_t('新建子团队') : i18n_t('新增团队');
    });
    const { orgSpaceSize, orgSpace, listTeam, getOrgSpaceInfo } = teamHandler(0, props.needCheckManagementPermission);

    // 团队名称校验
    const { rules } = userValidator(formData);
    const nameRule = {
      name: rules.teamName,
    };
    const nameValidated = ref(true);
    const spaceConfigChanged = computed(() => {
      let initSpaceConfig;
      if (props.currentNode.noSpace) {
        initSpaceConfig = 'noSpace';
      } else {
        initSpaceConfig = props.currentNode.space === null ? 'shared' : 'customed';
      }
      return initSpaceConfig !== spaceConfig.value;
    });
    const sizeIsNull = computed(() => !size.value || size.value === '0');
    const currSize = computed(() => formatSize2Byte(size.value, formData.unit));
    const sizeChanged = computed(() => {
      const currNum = formatSize2Byte(size.value, formData.unit);
      const initNum = isEdit.value ? props.currentNode.space : '';
      const changed = +initNum !== currNum;
      return changed;
    });
    const usedSize = computed(() => formatSize2Byte(`${usedInfo.size}`, usedInfo.unit));

    // 当前输入的空间大于企业剩余空间大小
    const currSizeMoreThanOrgSize = computed(() => +orgSpaceSize.value > -1 && currSize.value > +orgSpaceSize.value);
    // 当前输入的空间小于自身已使用大小
    const currSizeLessThanUsedSize = computed(() => currSize.value < usedSize.value);
    const sizeDisabled = computed(() => {
      if (!sizeChanged.value) return sizeIsNull.value;
      if (isEdit.value) {
        return (
          spaceConfig.value === 'customed' &&
          (sizeIsNull.value || currSizeLessThanUsedSize.value || currSizeMoreThanOrgSize.value)
        );
      }
      return spaceConfig.value === 'customed' && (sizeIsNull.value || currSizeMoreThanOrgSize.value);
    });
    const nameDisabled = computed(() => formData.name === '' || !nameValidated.value);
    // 禁用保存按钮
    const submitDisabled = computed(() => {
      if (isEdit.value) {
        if (nameDisabled.value || sizeDisabled.value) return true;
        const nameIsEqual = formData.name === currentName.value;
        const roleIsEqual = formData.role === currentRole.value;
        let sizeIsEqual = false;
        if (spaceConfigChanged.value) {
          sizeIsEqual = false;
        } else {
          sizeIsEqual =
            spaceConfig.value === 'customed'
              ? formatSize2Byte(size.value, formData.unit) ===
                formatSize2Byte(currentTeamSpace.size, currentTeamSpace.unit)
              : true;
        }
        if (nameIsEqual && roleIsEqual && sizeIsEqual) return true;
        return false;
      }
      return nameDisabled.value || sizeDisabled.value;
    });
    const defaultTeamRoleId = computed(() => store.getters.defaultTeamOptions?.defaultRoleId || defaultRoleId.value);
    const methods = {
      // 新增时初始化弹窗
      initFormData() {
        const defaultSize = store.getters.defaultTeamOptions.spaceQuotaSize || ConstantConfig.defaultTeamSpaceSize;
        // 新企业spaceQuotaSize为undefined 设置共享额度时为null
        if (
          store.getters.defaultTeamOptions.spaceQuotaSize === null ||
          store.getters.defaultTeamOptions.spaceQuotaSize === undefined
        ) {
          spaceConfig.value = 'shared';
        } else {
          spaceConfig.value = 'customed';
        }
        // 无空间团队初始化上级团队为自己的父节点 因为无空间团队不能再新建子节点
        const parentName = props.currentNode.noSpace ? props.parentName : props.currentNode.name;
        const parentId = props.currentNode.noSpace ? props.parentId : props.currentNode.id;
        Object.assign(formData, {
          name: '',
          spaceQuotaSize: `${formatSize(defaultSize, true).size}`,
          unit: formatSize(defaultSize, true).unit,
          parentName,
          parentId,
          role: defaultTeamRoleId.value,
        });
      },
      // 加载子节点
      async load(node: TreeNodeModel) {
        const teamId = node.data?.id || '';
        const res = await listTeam({
          teamId,
          withPath: false,
          withNoSpaceTeams: 1,
        });
        const subTeam = (res.children as SMH.TeamTreeNode[]).map(item => ({
          ...item,
          children: item.children && (item.children as SMH.TeamTreeNode[]).length > 0,
        }));
        return subTeam;
      },
      selectNode(
        value: Array<TreeSelectValue>,
        context: {
          node: TreeNodeModel;
        },
      ) {
        const { node } = context;
        if (!node) {
          return;
        }
        formData.parentId = node.data.id;
        formData.parentName = node.data.name;
      },
      submit() {
        let byteSize: string | null = '';
        if (spaceConfig.value === 'shared') {
          byteSize = null;
        } else if (spaceConfig.value === 'customed') {
          byteSize = `${Number(size.value) * sizeMap[unit.value]}`;
        }
        // 从无空间改为有空间的标志
        const isNewOpenSpace = props.currentNode.noSpace && spaceConfig.value !== 'noSpace';
        if (isEdit.value) {
          const teamInfo = {
            name: formData.name,
            spaceQuotaSize: byteSize,
            defaultRoleId: formData.role,
          };
          context.emit('onSubmit', teamInfo, isNewOpenSpace);
        } else {
          const newTeamInfo = {
            name: formData.name,
            spaceQuotaSize: byteSize,
            parentId: formData.parentId,
            parentName: formData.parentName,
            defaultRoleId: formData.role,
            noSpace: spaceConfig.value === 'noSpace',
          };
          context.emit('onSubmit', newTeamInfo);
        }
      },
      openHelp() {
        context.emit('open-help');
      },
      spaceConfigChange(val: string) {
        // TODO 触发一次后就失效了？？？
        if (val === 'customed' && store.getters.editionFlag !== 'enterprise') {
          spaceConfig.value = 'shared';
          // 团队版选中时弹窗提示
          upgradeDialog.show({
            source: 'member_space_assigned_limit',
            header: i18n_t('暂不支持分配指定额度'),
            body: i18n_t('当前版本仅支持共享企业剩余额度，升级企业版可自由分配团队可用额度'),
          });
        }
      },
    };
    watch(innerShow, newVal => {
      treeData.value = [];
      // 初始化弹窗数据
      if (newVal) {
        Object.assign(formData, {
          parentName: props.parentName,
          parentId: props.parentId,
          role: defaultTeamRoleId.value,
        });
        if (isEdit.value) {
          currentName.value = props.currentNode.name;
          currentRole.value =
            (props.currentNode.defaultRoleId && +props.currentNode.defaultRoleId) || defaultTeamRoleId.value;
          const defaultSize = store.getters.defaultTeamOptions.spaceQuotaSize || ConstantConfig.defaultTeamSpaceSize;
          const sizeInfo = formatSize(props.currentNode.space || defaultSize, true);
          const currUsedInfo = formatSize(props.currentNode.used);
          Object.assign(usedInfo, {
            size: currUsedInfo.size,
            unit: currUsedInfo.unit,
          });
          currentTeamSpace.size = `${sizeInfo.size}`;
          currentTeamSpace.unit = sizeInfo.unit;
          Object.assign(formData, {
            name: props.currentNode.name,
            spaceQuotaSize: currentTeamSpace.size,
            unit: currentTeamSpace.unit,
            role: currentRole.value,
          });
          if (props.currentNode.noSpace) {
            spaceConfig.value = 'noSpace';
          } else {
            spaceConfig.value = props.currentNode.space === null ? 'shared' : 'customed';
            // 初始化查询企业当前剩余量
            getOrgSpaceInfo(+props.currentNode?.space || 0);
          }
        } else {
          // 初始化查询企业当前剩余量
          getOrgSpaceInfo(0);
          methods.initFormData();
        }
        if (!props.definiteTeam) {
          treeData.value = _.cloneDeep(props.teamData);
        }
      }
    });
    watch(formData, async (newVal, oldVal) => {
      // form没有抛出当前校验是否通过，拿dom判断下
      setTimeout(() => {
        const errorElement = document.querySelector('.team-name-form .t-form__controls.t-is-error');
        nameValidated.value = !errorElement;
      }, 20);
    });
    return {
      innerShow,
      title,
      isEdit,
      usedInfo,
      teamNameMaxLength,
      nameRule,
      nameValidated,
      formData,
      spaceConfig,
      orgSpaceSize,
      orgSpace,
      currentTeamSpace,
      size,
      unit,
      currSizeMoreThanOrgSize,
      currSizeLessThanUsedSize,
      sizeDisabled,
      submitDisabled,
      sizeOptions,
      treeData,
      treeKeys,
      ...methods,
    };
  },
});
